import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="row">
          <div className="col-md-4">
            <div className="inner-fooseg">
              <img 
                src="/assets/logo.svg" 
                alt="S. V. Gadag Ginning Factory" 
                className="logofoot"
              />
              <address>
                <br />                           
                <strong>S. V. Gadag Ginning Factory</strong> <br />
                (A Govt. of India recognized 3 Star <i className="fa fa-star" style={{color: '#f39c12'}}></i><i className="fa fa-star" style={{color: '#f39c12'}}></i><i className="fa fa-star" style={{color: '#f39c12'}}></i> Export House), <br />
                An ISO 22000:2005 Certified Company. <br />
                Exporter of Groundnut Seeds <br />
                <br />
                <strong>Head Office (Processing Unit):</strong><br />
                Gadag - 582101, Karnataka, India<br />
                <br />
                <strong>Gujarat Unit:</strong><br />
                Shed No 2A L S No 49/1, Gundala Patri<br />
                Road, Gundala, Tal, Mundra, Kachchh<br />
                Gujarat, 370410, India
              </address>
            </div>
          </div>
          <div className="col-md-8">
            <div className="row">
              <div className="col-md-3">
                <div className="inner-fooseg">
                  <h4>Quick Links</h4>
                  <ul>
                    <li><Link to="/">Home <i className="fa fa-caret-right"></i></Link></li>
                    <li><Link to="/about/about-us">About Us <i className="fa fa-caret-right"></i></Link></li>
                    <li><Link to="/products">Products <i className="fa fa-caret-right"></i></Link></li>
                    <li><Link to="/quality">Quality <i className="fa fa-caret-right"></i></Link></li>
                    <li><Link to="/about/careers">Careers <i className="fa fa-caret-right"></i></Link></li>
                    <li><Link to="/contact-us">Contact Us <i className="fa fa-caret-right"></i></Link></li>
                  </ul>
                </div>
              </div>
              <div className="col-md-5">
                <div className="inner-fooseg">
                  <h4>Products</h4>
                  <ul>
                    <li><Link to="/products#peanut-java">Peanut JAVA/TJ <i className="fa fa-caret-right"></i></Link></li>
                    <li><Link to="/products#peanut-bold">Peanut Bold (RUNNER) <i className="fa fa-caret-right"></i></Link></li>
                    <li><Link to="/products#peanut-blanched-whole">Peanut Roasted & Blanched (WHOLE) <i className="fa fa-caret-right"></i></Link></li>
                    <li><Link to="/products#peanut-roasted-blanched-split">Peanut Roasted & Blanched (SPLIT) <i className="fa fa-caret-right"></i></Link></li>
                    <li><Link to="/products#peanut-in-shell">Peanut in Shell <i className="fa fa-caret-right"></i></Link></li>
                  </ul>
                </div>
              </div>
              <div className="col-md-4">
                <div className="inner-fooseg">
                  <h4>Company</h4>
                  <ul>
                    <li><Link to="/about/about-us">About Us<i className="fa fa-caret-right"></i></Link></li>
                    <li><Link to="/about/infrastructure">Infrastructure <i className="fa fa-caret-right"></i></Link></li>
                    <li className="spl-foolistin"><strong>Phone:</strong></li>
                    <li><a href="tel:+919448165266">+91 944 816 5266</a></li>
                    <li><a href="tel:+917975855377">+91 797 585 5377</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>        
          <div className="col-md-12">
            <hr />
          </div>
        </div>
        <div className="row">
          <div className="col-md-8">
            <p className="cpyrt">
              Copyright © {new Date().getFullYear()}. All rights reserved 
            </p>
          </div>
        </div>    
      </div>
    </footer>
  );
};

export default Footer;
